<nz-page-header nzTitle="Communication Log"></nz-page-header>
<nz-table *ngIf="logs" nzSize="default" 
	[nzData]="logs" 
	[nzFrontPagination]="false"
	[nzBordered]="true"
	[nzLoading]="loading"
	[nzTotal]="total"
	[nzPageSize]="pageSize"
	[nzPageIndex]="pageIndex"
	[nzShowSizeChanger]="true"
	[nzPageSizeOptions]="[5, 10, 15, 20, 25, 50, 100]"
	(nzQueryParams)="onQueryParamsChange($event, getThis())">
	<thead>
		<tr>
			<th>ID</th>
			<th>Created At</th>
			<th>Channel</th>
			<th>Subject</th>
			<th>Message</th>
			<th>Run Date</th>
			<th>Next Run Date</th>
			<th>Receipient Count</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of logs">
			<td>{{item.id}}</td>
			<td>{{item.createdAt | date:'yyyy-MM-dd HH:mm'}}</td>
			<td>{{item.channel}}</td>
			<td>{{item.subject}}</td>
			<td>{{item.body}}</td>
			<td>{{item.runDate | date:'yyyy-MM-dd HH:mm'}}</td>
			<td>{{item.nextRunDate | date:'yyyy-MM-dd HH:mm'}}</td>
			<td [ngClass]="{'text-danger': item.eligibleMemberCount === 0}">{{item.eligibleMemberCount}}</td>
		</tr>
	</tbody>
</nz-table>